export const languageOptions = [
  // { tag: 'cs-CZ', name: 'čeština (Česko)' },
  // { tag: 'de-DE', name: 'Deutsch (Deutschland)' },
  { tag: 'en-US', name: 'English (United States)' },
  // { tag: 'es-ES', name: 'español (España, alfabetización internacional)' },
  // { tag: 'fr-FR', name: 'français (France)' },
  // { tag: 'it-IT', name: 'italiano (Italia)' },
  // { tag: 'jp-JP', name: '日本語 (日本)' },
  // { tag: 'ko-KR', name: '한국어(대한민국)' },
  // { tag: 'pl-PL', name: 'polski (Polska)' },
  // { tag: 'pt-BR', name: 'português (Brasil)' },
  // { tag: 'ru-RU', name: 'русский (Россия)' },
  // { tag: 'tr-TR', name: 'Türkçe (Türkiye)' },
  // { tag: 'zh-CN', name: '中文(中国)' },
  // { tag: 'zh-HK', name: '中文(香港特別行政區)' },
]
